<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'voucher'+order.id">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" id="paste_img" class="el-dialog-lg" :close-on-click-modal="false" :visible.sync="dialogFormVisible" :modal="!mobiletype" width="100%" fullscreen @close="close()">
        <div class="hearderLogo">
            <HeaderSimple></HeaderSimple>
        </div>
        <div class="voucherBody">
            <h3 class="text-center voucherTitle">下单凭证</h3>
            <div style="margin-bottom:40px;overflow:hidden;">
                <div style="float:left;margin-right:60px;" v-if="order.business.website"><a :href='order.business.website.substr(0,7).toLowerCase() == "http://" || order.business.website.substr(0,8).toLowerCase() == "https://" ? order.business.website : "http://"+ order.business.website' target="_blank" style="color:#333333;">商家: {{order.business_name}}</a></div>
                <div style="float:left;margin-right:60px;" v-else>商家: 未指定</div>
                <div style="float:left;" v-if="order.business_order_no">商家订单#：{{order.business_order_no}}</div>
            </div>
            <ul class="voucherLists">
                <li v-if="isSingle">
                    <div class="voucherList uploadLI">
                        <div v-if="!openSelect">
                            <div class="selectUpload" @click="openSelect = true">
                                <div class="upload-demo"></div>
                                <div class="upload-title">上传文件/图片</div>
                            </div>
                            <div class="upload-text">商家邮件转发至track@JoyOrders.com后将自动解析显示</div>
                        </div>
                        <div v-if="openSelect" class="is-active">
                            <div class="uploadList" style="margin-bottom:28px">
                                <el-upload
                                :action="API_HOST + '/api/order.php?api=upload_voucher_file'"
                                :headers="headers"
                                :http-request="handleSuccess"
                                :before-upload="handleBeforeUpload"
                                :multiple='false'
                                :data="OrderVoucher"
                                accept=".eml,.jpg,.jpeg,.png,.doc,.docx,.pdf"
                                name="voucher_file"
                                >
                                <div class="uploadList" @click="currentVoucher = OrderVoucher">+ 订单凭证</div></el-upload>
                            </div>
                            <div class="uploadList" style="margin-bottom:28px">
                                <el-upload
                                :action="API_HOST + '/api/order.php?api=upload_voucher_file'"
                                :headers="headers"
                                :http-request="handleSuccess"
                                :before-upload="handleBeforeUpload"
                                :multiple='false'
                                :data="OrderVoucher"
                                accept=".eml,.jpg,.jpeg,.png,.doc,.docx,.pdf"
                                name="voucher_file"
                                >
                                <div class="uploadList" style="margin-bottom:28px" @click="currentVoucher = DeliveryVoucher">+ 发货凭证</div></el-upload>
                            </div>
                            <div class="uploadList" style="margin-bottom:28px">
                                <el-upload
                                :action="API_HOST + '/api/order.php?api=upload_voucher_file'"
                                :headers="headers"
                                :http-request="handleSuccess"
                                :before-upload="handleBeforeUpload"
                                :multiple='false'
                                :data="OrderVoucher"
                                accept=".eml,.jpg,.jpeg,.png,.doc,.docx,.pdf"
                                name="voucher_file"
                                >
                               <div class="uploadList" @click="currentVoucher = OtherVoucher">+ 其他凭证</div></el-upload>
                            </div>
                        </div>
                    </div>
                    <div class="voucherFooter">
                        支持 eml、jpg、jpeg、png、doc、docx、pdf 格式，大小不能超过20M
                    </div>
                </li>

                <li v-for="(item,index) in voucherList" :key='index'>
                    <div class="voucherList uploadLI">
                        <!--<div class="bgPicture" v-if="['.jpg','.jpeg','.png'].indexOf(item.url.substring(item.url.lastIndexOf('.'),item.url.length)) > -1">-->
                          <div class="bgPicture">
                            <img :src="item.url" @click="enlarge(item)">
                            <el-dialog v-if="item.dialogBgPicture" :visible.sync="item.dialogBgPicture" width="50%"  @close="showForm = false" append-to-body>
                                <img :src="item.url" style="width: 100%;margin-bottom:25px;">
                            </el-dialog>
                        </div>
                        <div class="bgIcon" v-if="['.html','.doc','.docx','.pdf'].indexOf(item.url.substring(item.url.lastIndexOf('.'),item.url.length)) > -1">
                            <a :href="item.url" target='_blank'><img src="../../../ico/eml@2x.png" style="width:100%;" v-if="item.url.substring(item.url.lastIndexOf('.'),item.url.length) == '.html'"></a>
                            <a :href="item.url" target='_blank'><img src="../../../ico/PDF@2x.png" style="width:100%;" v-if="item.url.substring(item.url.lastIndexOf('.'),item.url.length) == '.pdf'"></a>
                            <a :href="item.url" target='_blank'><img src="../../../ico/word@2x.png" style="width:100%;" v-if="['.doc','.docx'].indexOf(item.url.substring(item.url.lastIndexOf('.'),item.url.length)) > -1"></a>
                        </div>
                        <div class="operations on" v-if="isSingle && item.canEdit">
                            <div class="operation" style="margin-right: 10px;">
                                <el-upload
                                :action="API_HOST + '/api/order.php?api=upload_voucher_file'"
                                :headers="headers"
                                :http-request="replaceSuccess"
                                :before-upload="handleBeforeUpload"
                                :data="OrderVoucher"
                                :multiple='false'
                                accept=".eml,.jpg,.jpeg,.png,.doc,.docx,.pdf"
                                name="voucher_file"
                                ><div class="operation replace"  @click="currentVoucher = item"></div></el-upload>
                            </div>
                            <div class="operation del" @click="del(item)">

                            </div>
                        </div>
                        <div class="selectVoucherToImage" :class="{'noSingle':!isSingle}" v-if="needChoose" @click="selectVoucherToImage(item)">
                          选中图片
                        </div>
                        <div class="selectVoucher" :class="{'noSingle':!isSingle}" @click="openOption(item)" v-for="(list,i) in vouchers" v-if="item.type == list.type">
                            {{list.name}}
                            <i class="arrow" :class="item.openOptions?'open':''" v-if="isSingle"></i>
                        </div>
                        <div class="voucherOptions" v-if="item.openOptions">
                            <div class="options" style="border-bottom: 1px solid #E1E1E1;" @click="change(item,1)">
                                订单凭证
                            </div>
                            <div class="options" style="border-bottom: 1px solid #E1E1E1;" @click="change(item,2)">
                                发货凭证
                            </div>
                            <div class="options" @click="change(item,3)">
                                其他凭证
                            </div>
                        </div>
                    </div>
                    <div class="voucherFooter">
                        <div class="voucherName" v-if="item.readonly" style="overflow-y: auto;">
                            {{item.name}}
                            <i class="pencil" @click="edit(item)"></i>
                        </div>
                        <textarea v-if="!item.readonly" class="voucherName" maxlength="120" :class="item.readonly?'':'is-edit'" v-model="item.name" @ @blur="updateName(item)"></textarea>
                    </div>
                </li>

            </ul>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../services/api.js'
import Loading from '../../../components/Loading'
import HeaderSimple from '../../../components/HeaderSimple'
import { API_HOST, FILE_HOST } from '../../../services/constant.js'
let _ = require('lodash')

export default {
  name: 'OrderVoucher',
  props: ['order', 'groupOrderLine', 'isSingle', 'mobiletype', 'needChoose'],
  components: {
    Loading: Loading,
    HeaderSimple: HeaderSimple
  },
  computed: {
  },
  data () {
    return {
      API_HOST: API_HOST,
      dialogFormVisible: false,
      dialogBgPicture: false,
      loading: false,
      voucherList: null,
      currentVoucher: null,
      openSelect: false,
      OrderVoucher: {
        name: '订单凭证',
        type: 1
      },
      DeliveryVoucher: {
        name: '发货凭证',
        type: 2
      },
      OtherVoucher: {
        name: '其他凭证',
        type: 3
      },
      vouchers: [
        {name: '订单凭证', type: 1},
        {name: '发货凭证', type: 2},
        {name: '其他凭证', type: 3}
      ],
      type: null,
      name: null,
      url: null,
      headers: {}
    }
  },
  mounted () {

  },
  created () {
    this.headers.token = this.$localStorage.get('token')
  },
  methods: {
    show (e) {
      this.dialogFormVisible = true
      this.getInfo()
      window.addEventListener('paste', this.pasteImg)
    },
    pasteImg (event) {
      let that = this
      if (event.clipboardData || event.originalEvent) {
        var clipboardData = (event.clipboardData || event.originalEvent.clipboardData)
        if (clipboardData.items) {
          var items = clipboardData.items,
            len = items.length,
            file = null
          event.preventDefault()
          for (var i = 0; i < len; i++) {
            if (items[i].type.indexOf('image') !== -1) {
              file = items[i].getAsFile()
            }
          }
          if (file !== null) {
            var reader = new FileReader()
            reader.onload = function (event) {
              let fd = new FormData()
              fd.append('voucher_file', file)
              that.uploadImgByPaste(fd)
            }
            reader.readAsDataURL(file)
          }
        }
      }
    },
    selectVoucherToImage (item) {
      this.$emit('selectProductImage', item)
      this.dialogFormVisible = !this.dialogFormVisible
      this.close()
    },
    uploadImgByPaste (file) {
      let FileController = this.API_HOST + '/api/order.php?api=upload_voucher_file'
      this.$http.post(FileController, file).then((res) => {
        if (res.body.status !== 'ok') {
          this.$message.error('上传失败：' + response.result)
          return
        }
        if (res.body.status == 'ok') {
          this.type = 1
          this.url = res.body.result
          this.name = '通过粘贴上传图片'
          console.log(this.url)
          this.addVoucher()
        }
      })
    },
    async getInfo () {
      let query = {
        order_id: this.order.id
      }
      let res = await api.getVoucherList(this, query)
      let voucherList = res.body.result
      _.each(voucherList, item => {
        // console.log(item.url.substring(item.url.lastIndexOf('.'),item.url.length))
        item.openOptions = false
        item.readonly = true
        item.dialogBgPicture = false
        item.canEdit = item.create_account_id==this.$localStorage.get('account_id')
      })
      this.voucherList = voucherList
      console.log('this.voucherList',this.voucherList)
    },
    handleBeforeUpload (file) {
      file.currentVoucher = this.currentVoucher
      let isLt2M = file.size / 1024 / 1024 < 20
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 20MB!',
          type: 'warning'
        })
      }
      console.log(file)
    },
    handleSuccess: function (param) {
      let fileObj = param.file
      let FileController = this.API_HOST + '/api/order.php?api=upload_voucher_file'
      let form = new FormData()
      form.append('voucher_file', fileObj)
      this.$http.post(FileController, form).then((res) => {
        console.log(res)
        if (res.body.status !== 'ok') {
          this.$message.error('上传失败：' + response.result)
          return
        }
        if (res.body.status == 'ok') {
          this.type = param.file.currentVoucher.type
          this.name = param.file.name
          this.url = res.body.result
          this.addVoucher()
        }
      })
    },
    replaceSuccess: function (param) {
      let fileObj = param.file
      let FileController = this.API_HOST + '/api/order.php?api=upload_voucher_file'
      let form = new FormData()
      form.append('voucher_file', fileObj)
      this.$http.post(FileController, form).then((res) => {
        console.log(res)
        if (res.body.status !== 'ok') {
          this.$message.error('上传失败：' + response.result)
          return
        }
        if (res.body.status == 'ok') {
          this.type = param.file.currentVoucher.type
          this.name = param.file.name
          this.url = res.body.result
          this.replace(param.file.currentVoucher)
        }
      })
    },
    async addVoucher () {
      let res = await api.post(this, {
        path: 'order.php',
        api: 'add_voucher',
        data: {
          order_id: this.order.id,
          type: this.type,
          name: this.name,
          url: this.url
        },
        loading: 'loading'
      })
      if (res.body.status == 'ok') {
        this.getInfo()
      }
    },
    enlarge (item) {
      item.dialogBgPicture = true
      this.$forceUpdate()
    },
    openOption (item) {
      if (!this.isSingle) {
        return
      }
      _.each(this.voucherList, list => {
        if (item.id == list.id) {
          item.openOptions = !item.openOptions
        } else {
          list.openOptions = false
        }
      })
      this.$forceUpdate()
    },
    edit (item) {
      item.readonly = false
      this.$forceUpdate()
    },
    async updateName (item) {
      let res = await api.post(this, {
        path: 'order.php',
        api: 'update_voucher_name',
        data: {
          id: item.id,
          name: item.name
        },
        loading: 'loading'
      })
      if (res.body.status == 'ok') {
        item.readonly = true
        this.$forceUpdate()
      }
    },
    async change (item, data) {
      let res = await api.post(this, {
        path: 'order.php',
        api: 'replace_voucher',
        data: {
          id: item.id,
          order_id: this.order.id,
          type: data,
          name: item.name,
          url: item.url
        },
        loading: 'loading'
      })
      if (res.body.status == 'ok') {
        item.openOptions = false
        item.type = data
        this.$forceUpdate()
      }
    },
    async replace (item) {
      let res = await api.post(this, {
        path: 'order.php',
        api: 'replace_voucher',
        data: {
          id: item.id,
          order_id: this.order.id,
          type: this.type,
          name: this.name,
          url: this.url
        },
        loading: 'loading'
      })
      if (res.body.status == 'ok') {
        this.getInfo()
      }
    },
    async del (item) {
      let res = await api.post(this, {
        path: 'order.php',
        api: 'delete_voucher',
        data: {
          id: item.id
        },
        loading: 'loading'
      })
      if (res.body.status == 'ok') {
        this.getInfo()
      }
    },
    close () {
      this.openSelect = false
      window.removeEventListener('paste', this.pasteImg)
    }
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hearderLogo {
    position: absolute;
    width: 80%;
    top: 0;
    left: 10%;
    .header {
        padding: 50px 0;
    }
}
.voucherBody {
    width: 980px;
    min-height: 874px;
    overflow: hidden;
    margin: 72px auto 60px;
    background: #ffffff;
    padding: 40px 5px 40px 60px;

    .voucherTitle {
        font-size: 18px;
        color: #333333;
        font-weight:500;
        letter-spacing:2px;
        margin-bottom: 61px;
        padding-right: 55px;
    }
    .voucherLists {
        li {
            float: left;
        }
        .voucherList {
            position: relative;
            height: 250px;
            width: 250px;
            margin-right: 55px;

            .bgPicture {
                height: 250px;
                width: 250px;
                overflow: hidden;

                img {
                    height: 250px;
                    width: 250px;
                    object-fit: contain;
                }
            }
            .bgIcon {
                width: 60px;
                height: 60px;
                margin: 95px;
            }

            .operations {
                display: none;
                position: absolute;
                left: 15px;
                bottom: 15px;
                z-index: 100;
                width:106px;
                height:30px;

                .operation {
                    float: left;
                    width:30px;
                    height:30px;
                    background:rgba(51,51,51,1);
                    border-radius:15px;
                    cursor: pointer;
                }
                .replace {
                    background: url('../../../ico/replace@2x.png');
                    background-size: cover;
                }
                .del {
                    background: url('../../../ico/delete@2x.png');
                    background-size: cover;
                }
            }

            .selectVoucherToImage{
                position: absolute;
                right: 15px;
                bottom: 50px;
                z-index: 100;
                width:106px;
                height:30px;
                background:rgba(51,51,51,1);
                border-radius:15px;
                font-size: 12px;
                line-height: 30px;
                padding-left: 22px;
                color: #ffffff;
                cursor: pointer;
                padding-right: 15px;
                text-align: center;
            }
            .selectVoucher {
                position: absolute;
                right: 15px;
                bottom: 15px;
                z-index: 100;
                width:106px;
                height:30px;
                background:rgba(51,51,51,1);
                border-radius:15px;
                font-size: 12px;
                line-height: 30px;
                padding-left: 22px;
                color: #ffffff;
                cursor: pointer;
                text-align: center;

                &.noSingle {
                    padding-right: 15px;
                }
                .arrow {
                    float: right;
                    width: 10px;
                    height: 5px;
                    text-align: center;
                    display: inline-block;
                    background: url('../../../ico/el-icon-arrow-down@2x.png');
                    background-size: cover;
                    margin-right: 12px;
                    margin-top: 13px;
                    transition: transform .3s;

                    &.open {
                        transform: rotate(180deg);
                    }
                }

            }
            .voucherOptions {
                position: absolute;
                right: 15px;
                bottom: -84px;
                z-index: 99;
                width:106px;
                height:115px;
                background:rgba(255,255,255,1);
                box-shadow:0px 3px 6px 0px #E2E2E2;
                border-radius:0px 0px 15px 15px;
                padding-top: 15px;

                .options {
                    padding: 10px 19px;
                    margin: 0 10px;
                    font-size: 12px;
                    color: #666666;
                    cursor: pointer;
                }
            }
        }
        .uploadLI {
            border: 1px dashed #d9d9d9;

            .selectUpload {
                cursor: pointer;
            }

            .upload-demo {
                display: inline-block;
                margin: 70px 109px 13px;
                height: 28px;
                width: 30px;
                background: url('../../../ico/upload@2x.png');
                background-size: 38px 38px;
                background-position: -4px -6px;
            }
            .upload-title {
                text-align: center;
                font-size: 16px;
                color: #666666;
                margin-bottom: 20px;
            }
            .upload-text {
                text-align: center;
                line-height: 16px;
                font-size: 10px;
                color: #999999;
                padding: 0 20px;
                word-break: break-all;
            }
            .off {
                display: block;
            }
            .is-active {
                margin: 60px 71px 60px 72px;

                .uploadList {
                    text-align: center;
                    height: 30px;
                    background:rgba(244,244,250,1);
                    border-radius:15px;
                    font-size: 12px;
                    color: #666666;
                    line-height: 30px;
                }
            }

        }
        .voucherList:hover {
            .on {
                display: block;
            }
        }

        .voucherFooter {
            position: relative;
            width: 250px;
            height: 34px;
            margin-top: 20px;
            color: #666666;
            font-size: 12px;
            text-align: left;
            margin-bottom: 40px;
            line-height: 16px;
            overflow: hidden;

            .voucherName {
                word-break: break-all;
                border-width: 0;
                padding: 0;
                font-size: 12px;
                color: #666666;
                width: 100%;
                height: 100%;
                resize:none;

                &.is-edit {
                    border-width: 1px;
                }
            }

            .pencil {
                display: none;
                width: 10px;
                height: 10px;
                background: url('../../../ico/edit@2x.png');
                background-size: cover;
                cursor: pointer;
            }
        }
         .voucherFooter:hover {
            .pencil {
                display: inline-block;
            }
        }
    }
}
@media screen and (max-width: 1024px) {
    .voucherBody {
        width: auto !important;
        min-height: auto !important;
        padding: 40px 5px 40px 100px;
    }
  }
  @media screen and (max-width: 500px) {
    .voucherBody {
        width: auto !important;
        min-height: auto !important;
        padding: 40px 5px 40px 80px;
    }
  }
  @media screen and (max-width: 400px) {
    .voucherBody {
        padding: 40px 5px 40px 60px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/merchantOrders/list/OrderVoucher.vue